<template>
    <button
        type="button"
        class="menu-item"
        :class="[tone ? `tone-${tone}` : '', { 'is-active': active }]"
        :disabled="disabled"
        @click="$emit('click', $event)"
    >
        <span v-if="icon" class="menu-item-icon-box">
            <inline-svg
                class="menu-item-icon"
                :class="{ filled: filledIcon }"
                :src="require(`@/assets/icons/${icon}`)"
            />
        </span>
        <span class="menu-item-text">
            <span class="menu-item-label">{{ label }}</span>
            <span v-if="hint" class="menu-item-hint">{{ hint }}</span>
        </span>
        <inline-svg
            v-if="active"
            class="menu-item-check"
            :src="require('@/assets/icons/check.svg')"
        />
    </button>
</template>

<script>
export default {
    name: 'MenuItem',
    props: {
        label: { type: String, default: '' },
        hint: { type: String, default: '' },
        icon: { type: String, default: '' },
        filledIcon: { type: Boolean, default: false },
        tone: { type: String, default: '' },
        active: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false }
    },
    emits: ['click']
}
</script>

<style lang="scss" scoped>
.menu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-width: 190px;
    padding: 6px 10px 6px 6px !important;
    border: 0;
    background-color: transparent;
    border-radius: $radius-small;
    color: $color-white-text;
    text-align: left;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover {
        background-color: rgba($color-primary-blue, 0.16);
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;

        &:hover {
            background-color: transparent;
        }
    }
}

.menu-item-icon-box {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    border-radius: $radius-small;
    background-color: rgba($color-primary-blue, 0.18);
    color: $color-primary-blue;
}

.menu-item-icon {
    width: 15px;
    height: 15px;
    stroke: currentColor;
    fill: none;

    &.filled {
        fill: currentColor;
        stroke: none;
    }
}

.menu-item-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1 1 auto;
    min-width: 0;
}

.menu-item-label {
    font-size: $font-subtitle;
    color: inherit;
    white-space: nowrap;
}

.menu-item-hint {
    font-size: $font-small;
    color: $color-secondary-text;
    white-space: nowrap;
}

.menu-item-check {
    width: 15px;
    height: 15px;
    flex: 0 0 15px;
    color: $color-primary-blue;
    stroke: currentColor;
    fill: none;
}

.is-active .menu-item-label {
    color: $color-primary-blue;
}

.tone-danger {
    .menu-item-icon-box {
        background-color: rgba($color-pastel-red, 0.18);
        color: $color-pastel-red;
    }

    &:hover {
        background-color: rgba($color-pastel-red, 0.16);
        color: $color-pastel-red;
    }
}

.tone-success {
    .menu-item-icon-box {
        background-color: rgba($color-pastel-green, 0.18);
        color: $color-pastel-green;
    }

    &:hover {
        background-color: rgba($color-pastel-green, 0.16);
        color: $color-pastel-green;
    }
}

.tone-warning {
    .menu-item-icon-box {
        background-color: rgba($color-warning, 0.18);
        color: $color-warning;
    }

    &:hover {
        background-color: rgba($color-warning, 0.16);
        color: $color-warning;
    }
}
</style>
